/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_3_KInputs */

const en_mk_aicost_3_k = /** @type {(inputs: Mk_Aicost_3_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A daily routine for a whole month`)
};

const id_mk_aicost_3_k = /** @type {(inputs: Mk_Aicost_3_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas harian sebulan penuh`)
};

/**
* | output |
* | --- |
* | "A daily routine for a whole month" |
*
* @param {Mk_Aicost_3_KInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_3_k = /** @type {((inputs?: Mk_Aicost_3_KInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_3_KInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_3_k(inputs)
	return en_mk_aicost_3_k(inputs)
});